import React from "react";
import "./Review.css";

const Star = ({ filled }) => {
  return <span className={filled ? "star-on-png" : "star-off-png"}></span>;
};

const StarRating = ({ rating, width }) => {
  var stars = [];
  for (var i = 0; i < 5; i++) {
    stars.push(<Star key={i} filled={i < rating} />);
  }
  const newWidth = `${(rating / 5) * 100}%`;
  const nwidth = width ? width : newWidth;

  return (
    <div className="rating">
      <div className="stars" style={width ? { width: nwidth } : {}}>
        {stars}
      </div>
    </div>
  );
};

export default StarRating;



// WEBPACK FOOTER //
// ./src/shared/StarRating.js